import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { ValidationMsgs, datePicker_disabled, datePicker_no_range, validity_date_v2 } from 'src/app/core/Constants/static';

@Component({
  selector: 'app-payer-cap-integration',
  templateUrl: './payer-cap-integration.component.html',
  styleUrls: ['./payer-cap-integration.component.css']
})
export class PayerCapIntegrationComponent implements OnInit {

  // @Input() formGroupName!: string;
  @Input() submitted: boolean = false;
  @Input() isEdit: boolean = false;


  public showAddress: boolean = true;
  public payerCapForm !: FormGroup;
  public validity_date_v2 = validity_date_v2;
  public validity_date_disabled = datePicker_disabled;

  public validationMsg = ValidationMsgs.datePattern;
  public EndDateError = ValidationMsgs.EndDateError;
  public startDateError = ValidationMsgs.startDateError;
  public TypeofAPIArray = ['REST']//, 'soap', 'HL7', 'RPC'
  public authorizationArray = ['Client toke', 'Credentials']
  public methodArray =["POST","PUT","GET","DELETE","PATCH","OPTION",  ]
  public isCapAvilabel = 'off';


  constructor(
    public rootFormGroup: FormGroupDirective,
  ) { }

  ngOnInit() {
    this.rootFormGroup.form.controls['isCapShow'].valueChanges.subscribe((value:boolean)=>{
      if(value){
        this.payerCapForm = this.rootFormGroup.control.get('payerCapIntegration') as FormGroup;
      }
  })
  }

  check(){

  }

}
